var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg29(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 316.7 439.06",
    style: {
      fill: "#ffffff"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #05a0b6;\n      }\n\n      .cls-2 {\n        fill: #eaa13b;\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "0 439.06 316.7 439.06 316.7 7.2 215.93 0 0 7.2 0 439.06"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "anytime"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "122.28 241.91 165.36 241.91 165.36 331.79 90.12 331.79 90.12 288.06 122.28 241.91"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 43.19,
    y: 179.94,
    width: 79.17,
    height: 108.12
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m178.28,93.57H30.11c-16.56,0-30.11,13.55-30.11,30.11v278.12c0,16.6,13.46,30.06,30.06,30.06h148.56c16.56,0,30.11-13.55,30.11-30.11V123.38c0-16.44-13.65-29.81-30.45-29.81h0Zm-148.25,14.4h148.59c8.65,0,15.72,7.07,15.72,15.72v257.79H14.4V123.6c0-8.63,7-15.63,15.63-15.63Zm164.31,298.34c-2.01,8.63-9.07,15.66-17.73,11.15H30.43c-8.66,4.51-15.72-2.52-16.04-11.15v-10.44h179.94v10.44Zm-2.01,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.92,143.95h51.2c9.39-.06,9.42-14.37,0-14.4h-51.2c-9.39.03-9.42,14.34,0,14.4h0Zm87.44,93.57h-35.8v-57.58c0-3.98-3.22-7.2-7.2-7.2H43.19c-3.96,0-7.2,3.24-7.2,7.2v107.96c0,3.98,3.22,7.2,7.2,7.2h35.99v35.99c0,3.96,3.24,7.2,7.2,7.2h79.17c3.96,0,7.2-3.24,7.2-7.2v-86.6c0-3.84-3.32-6.97-7.38-6.97h0Zm-114.98-50.38h64.78v93.57H50.38v-93.57Zm107.96,136.76h-57.58v-28.79h21.94c3.99.46,6.85-6.74,6.85-6.74v-36.45h28.79v71.98ZM213.52,4.51c-42.82,0-80.38,27.33-93.48,68.04-2.81,9,10.74,13.33,13.69,4.41,30.68-90.14,162-69.41,163.67,25.81,0,41.03-30.51,76.65-70.94,82.89-8.66,1.27-7.59,14.4,1.07,14.31,119.52-21,107.76-191.67-14.01-195.46h0Zm0,0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m257.96,144.98c6.47.25,9.82-8.69,4.61-12.74,0,.03-39.45-32.84-39.45-32.84v-38.67c-.03-9.39-14.34-9.42-14.4,0v42.03c0,2.14.96,4.16,2.59,5.54l42.03,35c1.35,1.12,2.98,1.66,4.61,1.66h0Zm-2.41,0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg29);
export default __webpack_public_path__ + "static/media/29.aeb4a380012d3988dfef7eb413009942.svg";
export { ForwardRef as ReactComponent };